module.exports = __webpack_public_path__ + "img/onboarding6.36ef6754.png";